import React from 'react';
import {Route, Routes} from 'react-router-dom';

import {PATHS} from 'const';
import {Error, General, Home} from 'pages';

import './style.scss';

const View = props => {
	return (
		<div className="view">
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path={PATHS.PUBLIC.HOME} element={<Home />} />
				<Route path={PATHS.PUBLIC.GENERAL} element={<General />} />
				<Route path="*" element={<Error />} />
			</Routes>
		</div>
	);
};

export default View;
